module.exports = __webpack_public_path__ + "static/media/slack.136562e4.png";